import { GenericTableListTranslations } from './generic-table-list-translations.interface';

export const DEFAULT_GENERIC_TABLE_LIST_TRANSLATIONS: GenericTableListTranslations = {
  labels: {
    groupLabel: 'Table list',
    emptyList: 'No rows defined.',
    itemEntry: 'Row {index} of {total}',
  },
  buttons: {
    appendItem: 'Add row',
    appendItemLabel: 'Add row',
    removeItem: 'Delete row {index}',
  },
};
